module.exports = __webpack_public_path__ + "img/gh_pic02-5d210e.png";